<span class="toggle-feedback">{{{o.label_toggle}}}</span>
